module.exports = __webpack_public_path__ + "static/media/DayIcon.b261914a.png";